import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: "A stakeholder's perceived attitude toward the change",
    name: 'Stakeholder Perceived Attitude',
    partialId: PartialId.Standard.create('stakeholder_perceived_attitude'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
